import { render, staticRenderFns } from "./bazaar-voice-wrapper.vue?vue&type=template&id=250c20a6"
import script from "./bazaar-voice-wrapper.vue?vue&type=script&lang=js"
export * from "./bazaar-voice-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports